module.exports = __webpack_public_path__ + "img/grandes-alpes-courchevel.c1651248.jpg";